import { render, staticRenderFns } from "./ElementDialog.vue?vue&type=template&id=39a559ae&scoped=true"
import script from "./ElementDialog.vue?vue&type=script&lang=js"
export * from "./ElementDialog.vue?vue&type=script&lang=js"
import style0 from "./ElementDialog.vue?vue&type=style&index=0&id=39a559ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a559ae",
  null
  
)

export default component.exports